import ProfilesService from '@/services/modules/profiles.service';

const add = async({ commit }, _object) => {
    const response = ProfilesService.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }) => {
    const response = ProfilesService.get();

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};

const commissions = async({ commit }, _params) => {
    const response = ProfilesService.commissions(_params.profile_id, _params.administrator_id);
    
    response.then(function (_response) {
        commit('setCommission', _response);
    });
    
    return response;
};

const edit = async({ commit }, _module) => {
    const response = ProfilesService.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = ProfilesService.get(_id);

    response.then(function (_response) {
        if(_response.hasOwnProperty('visualization_all_branch')) {
            _response.visualization_all_branch = !!_response.visualization_all_branch;
        }
        if(_response.hasOwnProperty('profile_branch_visualizations')) {
            let branches = []
            _response.profile_branch_visualizations.forEach(branch => {
                         branches.push(branch.branches[0]);
            })
            _response.branches = branches;

        }
        console.log({_response})
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _module) => {
    const response = ProfilesService.rem(_module.id);

    return response;
};

export default {
    add,
    all,
    commissions,
    edit,
    get,
    rem
};